import React from 'react';

const NqmGuidelineInstructions = () => {
  return (
    <>
      <h2>Pipeline Q&A</h2>
      <br />
      <br />
      <ul>
        <li>
          You can use this GPT-enabled chat to ask questions about your
          Encompass pipeline.
        </li>
      </ul>
    </>
  );
};

export default NqmGuidelineInstructions;
